module.exports = __webpack_public_path__ + "media/assets/images/title_dairyreport-2f5055397ad27f3a788d924f658961f8.png";